/* ColaVita Glow — interacciones (vanilla, sin librerías) */
(function () {
  // Cada sección cv-* incluye este archivo: ejecutarlo una sola vez
  if (window.cvScriptsCargado) return;
  window.cvScriptsCargado = true;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll + cifras ---------- */
  var observer = null;
  function getObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('cv-visible');
        if (el.hasAttribute('data-cv-count')) countUp(el);
        observer.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    return observer;
  }

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.cv-reveal, [data-cv-count]');
    var obs = getObserver();
    els.forEach(function (el) {
      if (!obs || reduceMotion) {
        el.classList.add('cv-visible');
        if (el.hasAttribute('data-cv-count')) el.textContent = el.getAttribute('data-cv-count') + (el.getAttribute('data-cv-suffix') || '');
        return;
      }
      obs.observe(el);
    });
  }

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-cv-count')) || 0;
    var suffix = el.getAttribute('data-cv-suffix') || '';
    var decimals = (String(target).split('.')[1] || '').length;
    var dur = 1600, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(decimals) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var imgs = document.querySelectorAll('[data-cv-parallax]');
    if (!imgs.length || reduceMotion) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var k = parseFloat(img.getAttribute('data-cv-parallax')) || 0;
        var rect = img.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * k * -0.01;
        img.style.transform = 'translate3d(0,' + (offset - rect.height * 0.07) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Comparador antes / después ---------- */
  function initComparadores(root) {
    (root || document).querySelectorAll('.cv-comp').forEach(function (comp) {
      if (comp.dataset.cvInit) return;
      comp.dataset.cvInit = '1';
      var range = comp.querySelector('input[type=range]');
      if (!range) return;
      var set = function () { comp.style.setProperty('--pos', range.value + '%'); };
      range.addEventListener('input', set);
      set();
    });
  }

  /* ---------- Pestañas del antes/después ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-cv-tabs]').forEach(function (wrap) {
      if (wrap.dataset.cvInit) return;
      wrap.dataset.cvInit = '1';
      var tabs = wrap.querySelectorAll('.cv-ad__tab');
      var panels = wrap.querySelectorAll('.cv-ad__panel');
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove('is-activo'); t.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (p) { p.classList.remove('is-activo'); });
          tab.classList.add('is-activo'); tab.setAttribute('aria-selected', 'true');
          if (panels[i]) panels[i].classList.add('is-activo');
        });
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-cv-producto]').forEach(function (wrap) {
      if (wrap.dataset.cvInit) return;
      wrap.dataset.cvInit = '1';

      // Galería
      var principal = wrap.querySelector('.cv-prod__principal img');
      wrap.querySelectorAll('.cv-prod__thumb').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!principal) return;
          wrap.querySelectorAll('.cv-prod__thumb').forEach(function (b) { b.classList.remove('is-activo'); });
          btn.classList.add('is-activo');
          principal.style.opacity = '0';
          var src = btn.getAttribute('data-src'), srcset = btn.getAttribute('data-srcset');
          setTimeout(function () {
            principal.src = src;
            if (srcset) principal.srcset = srcset;
            principal.alt = btn.getAttribute('data-alt') || '';
            principal.style.opacity = '1';
          }, 180);
        });
      });

      // Cantidad
      var qty = wrap.querySelector('.cv-qty input');
      wrap.querySelectorAll('.cv-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var v = parseInt(qty.value, 10) || 1;
          v = b.getAttribute('data-dir') === 'mas' ? v + 1 : Math.max(1, v - 1);
          qty.value = v;
        });
      });

      // Variantes
      var dataEl = wrap.querySelector('[data-cv-variantes]');
      var selects = wrap.querySelectorAll('.cv-prod__opcion select');
      if (dataEl && selects.length) {
        var variants = [];
        try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
        var idInput = wrap.querySelector('input[name=id]');
        var btns = document.querySelectorAll('[data-cv-add]');
        var precio = wrap.querySelector('[data-cv-precio]');
        var antes = wrap.querySelector('[data-cv-antes]');
        var ahorro = wrap.querySelector('[data-cv-ahorro]');
        var moneyFormat = wrap.getAttribute('data-money-format') || '{{amount}} €';
        var textoAdd = wrap.getAttribute('data-texto-add');
        var textoAgotado = wrap.getAttribute('data-texto-agotado');
        var fmt = function (cents) {
          var amount = (cents / 100).toFixed(2);
          var comma = amount.replace('.', ',');
          return moneyFormat
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
            .replace(/\{\{\s*amount\s*\}\}/, amount);
        };
        var onChange = function () {
          var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
          btns.forEach(function (b) {
            b.disabled = !v || !v.available;
            var label = b.querySelector('[data-cv-add-label]');
            if (label) label.textContent = (!v || !v.available) ? textoAgotado : textoAdd;
          });
          if (!v) return;
          if (idInput) idInput.value = v.id;
          if (precio) precio.textContent = fmt(v.price);
          if (antes) {
            antes.style.display = v.compare_at_price > v.price ? '' : 'none';
            antes.textContent = v.compare_at_price ? fmt(v.compare_at_price) : '';
          }
          if (ahorro) {
            if (v.compare_at_price > v.price) {
              ahorro.style.display = '';
              ahorro.textContent = ahorro.getAttribute('data-prefijo') + ' ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
            } else { ahorro.style.display = 'none'; }
          }
          if (v.featured_image && principal) { principal.src = v.featured_image.src; principal.removeAttribute('srcset'); }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        };
        selects.forEach(function (s) { s.addEventListener('change', onChange); });
      }

      // Barra de compra fija (móvil)
      var sticky = document.querySelector('.cv-sticky-compra');
      var mainBtn = wrap.querySelector('.cv-prod__cantidad');
      if (sticky && mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', pasado);
          });
        }).observe(mainBtn);
        var stickyBtn = sticky.querySelector('button');
        var form = wrap.querySelector('form[action*="/cart/add"]');
        if (stickyBtn && form) {
          stickyBtn.addEventListener('click', function () {
            // Contra reembolso: abre el formulario de Releasit en vez de ir al pago con tarjeta
            var rsi = stickyBtn.hasAttribute('data-cv-sticky-cod') && document.getElementById('rsi_buy_now_button');
            if (rsi) { rsi.click(); return; }
            if (form.requestSubmit) form.requestSubmit(); else form.submit();
          });
        }
      }
    });
  }

  // Opiniones con fotos: filtros, orden, "ver más", visor de fotos y formulario
  function initOpiniones(root) {
    (root || document).querySelectorAll('[data-cv-opiniones]').forEach(function (sec) {
      if (sec.dataset.cvInit) return;
      sec.dataset.cvInit = '1';
      var grid = sec.querySelector('[data-cv-op-grid]');
      var modal = sec.querySelector('[data-cv-op-modal]');

      function abrirModal(el) { el.hidden = false; document.documentElement.classList.add('cv-op-bloqueo'); }
      function cerrarModal(el) { el.hidden = true; document.documentElement.classList.remove('cv-op-bloqueo'); }

      // Formulario "Escribir una opinión"
      if (modal) {
        sec.querySelectorAll('[data-cv-op-abrir-form]').forEach(function (b) {
          b.addEventListener('click', function () { abrirModal(modal); var i = modal.querySelector('input[type=text]'); if (i) i.focus(); });
        });
        modal.querySelectorAll('[data-cv-op-cerrar-form]').forEach(function (b) {
          b.addEventListener('click', function () { cerrarModal(modal); });
        });
        if (!modal.hidden) document.documentElement.classList.add('cv-op-bloqueo');
      }

      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.cv-op__card'));
      var porPagina = parseInt(sec.dataset.porPagina, 10) || 8;
      var limite = porPagina;
      var filtro = 'todas';
      var orden = sec.dataset.orden || 'destacadas';
      var mas = sec.querySelector('[data-cv-op-mas]');

      function coincide(c) {
        if (filtro === 'todas') return true;
        if (filtro === 'fotos') return c.dataset.fotos === 'true';
        return c.dataset.estrellas === filtro;
      }
      function ordenadas() {
        return cards.slice().sort(function (a, b) {
          var pa = +a.dataset.pos, pb = +b.dataset.pos;
          if (orden === 'mejor') return (b.dataset.estrellas - a.dataset.estrellas) || pa - pb;
          if (orden === 'fotos') return ((b.dataset.fotos === 'true') - (a.dataset.fotos === 'true')) || pa - pb;
          return pa - pb;
        });
      }
      function revisarLeerMas() {
        // Primero se escriben todas las clases, luego se mide todo y al final se aplica: un solo cálculo de layout
        var pares = [];
        cards.forEach(function (c) {
          var t = c.querySelector('.cv-op__texto'), b = c.querySelector('[data-cv-op-leer]');
          if (!t || !b || c.hidden || c.dataset.abierta) return;
          t.classList.add('is-corto');
          pares.push([t, b]);
        });
        var largos = pares.map(function (p) { return p[0].scrollHeight > p[0].clientHeight + 2; });
        pares.forEach(function (p, i) { p[1].hidden = !largos[i]; });
      }
      function pintar() {
        var visibles = 0, total = 0;
        ordenadas().forEach(function (c) {
          grid.appendChild(c);
          var ok = coincide(c);
          if (ok) total++;
          c.hidden = !(ok && visibles < limite);
          if (!c.hidden) visibles++;
        });
        if (mas) mas.hidden = total <= limite;
        revisarLeerMas();
      }

      sec.querySelectorAll('[data-cv-op-filtro]').forEach(function (b) {
        b.addEventListener('click', function () {
          filtro = b.dataset.cvOpFiltro;
          limite = porPagina;
          sec.querySelectorAll('.cv-op__chip').forEach(function (ch) {
            ch.classList.toggle('is-activo', ch.dataset.cvOpFiltro === filtro);
          });
          pintar();
          if (b.classList.contains('cv-op__barra')) {
            sec.querySelector('.cv-op__barra-filtros').scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
      var sel = sec.querySelector('[data-cv-op-orden]');
      if (sel) sel.addEventListener('change', function () { orden = sel.value; pintar(); });
      if (mas) mas.addEventListener('click', function () { limite += porPagina; pintar(); });

      grid.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cv-op-leer]');
        if (!b) return;
        var c = b.closest('.cv-op__card');
        c.dataset.abierta = '1';
        c.querySelector('.cv-op__texto').classList.remove('is-corto');
        b.hidden = true;
      });

      // Visor de fotos (recorre todas las fotos de todas las opiniones)
      var visor = sec.querySelector('[data-cv-op-visor]');
      var vImg = sec.querySelector('[data-cv-op-visor-img]');
      var vTxt = sec.querySelector('[data-cv-op-visor-txt]');
      var lista = [], idx = 0;
      function construirLista() {
        lista = [];
        ordenadas().forEach(function (c) {
          var tpl = c.querySelector('template[data-cv-op-grandes]');
          if (!tpl) return;
          Array.prototype.forEach.call(tpl.content.querySelectorAll('img'), function (img) {
            lista.push({ card: c, img: img, foto: img.dataset.foto });
          });
        });
      }
      function mostrar(i) {
        if (!lista.length) return;
        idx = (i + lista.length) % lista.length;
        var it = lista[idx];
        vImg.innerHTML = '';
        vImg.appendChild(it.img.cloneNode(true));
        var cuerpo = it.card.querySelector('.cv-op__cuerpo').cloneNode(true);
        var leer = cuerpo.querySelector('[data-cv-op-leer]');
        if (leer) leer.remove();
        var t = cuerpo.querySelector('.cv-op__texto');
        if (t) t.classList.remove('is-corto');
        vTxt.innerHTML = '';
        vTxt.appendChild(cuerpo);
        sec.querySelectorAll('[data-cv-op-nav]').forEach(function (n) { n.hidden = lista.length < 2; });
      }
      if (visor) {
        sec.addEventListener('click', function (e) {
          var b = e.target.closest('[data-cv-op-ver]');
          if (!b) return;
          construirLista();
          var id = b.dataset.cvOpVer, f = b.dataset.foto;
          var i = 0;
          lista.forEach(function (it, k) { if (it.card.dataset.id === id && it.foto === f) i = k; });
          abrirModal(visor);
          mostrar(i);
          visor.querySelector('.cv-op__visor-x').focus();
        });
        visor.querySelectorAll('[data-cv-op-cerrar]').forEach(function (b) {
          b.addEventListener('click', function () { cerrarModal(visor); });
        });
        visor.querySelectorAll('[data-cv-op-nav]').forEach(function (b) {
          b.addEventListener('click', function () { mostrar(idx + parseInt(b.dataset.cvOpNav, 10)); });
        });
      }
      document.addEventListener('keydown', function (e) {
        if (visor && !visor.hidden) {
          if (e.key === 'Escape') cerrarModal(visor);
          if (e.key === 'ArrowRight') mostrar(idx + 1);
          if (e.key === 'ArrowLeft') mostrar(idx - 1);
        } else if (modal && !modal.hidden && e.key === 'Escape') cerrarModal(modal);
      });

      pintar();
      window.addEventListener('resize', revisarLeerMas);

      // Estrellas junto al título del producto: nota real + enlace a las opiniones
      var rating = document.querySelector('.cv-prod__rating');
      if (rating && sec.dataset.total && !rating.dataset.cvOp) {
        var media = parseFloat(sec.dataset.media.replace(',', '.'));
        var a = document.createElement('a');
        a.className = rating.className;
        a.href = '#opiniones';
        a.dataset.cvOp = '1';
        a.innerHTML = '<span class="cv-op__estrellas" style="--cv-op-pct:' + (media * 20) + '%" aria-hidden="true">' +
          '<span class="cv-op__estrellas-base">★★★★★</span><span class="cv-op__estrellas-relleno">★★★★★</span></span>' +
          '<span><strong>' + sec.dataset.media + '</strong></span>';
        a.setAttribute('aria-label', sec.dataset.media + ' de 5 estrellas. Ver opiniones');
        a.addEventListener('click', function (e) { e.preventDefault(); sec.scrollIntoView({ behavior: 'smooth' }); });
        rating.replaceWith(a);
      }
    });
  }

  function initAll(root) {
    initReveals(root);
    initComparadores(root);
    initTabs(root);
    initProducto(root);
    initOpiniones(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    initParallax();
  });

  // Editor de Shopify: re-inicializa cuando se edita una sección
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
